import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PhaseHeader = ({ phase, projectName, onBack, isFuturePhase, previousPhaseProgress, estimatedStartDate }) => {
  return (
    <div className="bg-card border-b border-border pb-6">
      <div className="flex items-start justify-between mb-4">
        <Button
          variant="ghost"
          size="sm"
          iconName="ArrowLeft"
          onClick={onBack}
        >
          Back to Homepage
        </Button>
      </div>

      {projectName && (
        <div className="mb-4">
          <p className="text-sm text-muted-foreground mb-1">Project</p>
          <h2 className="text-xl font-bold text-foreground">{projectName}</h2>
        </div>
      )}

      <div className="flex items-center gap-4 mb-3">
        <h1 className="text-3xl font-bold text-foreground">{phase?.name}</h1>
        <span className={`px-3 py-1 rounded-full text-sm font-medium ${
          phase?.progress === 100 ? 'bg-success/10 text-success' :
          phase?.progress > 0 && phase?.progress < 100 ? 'bg-primary/10 text-primary' : 'bg-muted text-muted-foreground'
        }`}>
          {phase?.progress === 0 ? 'Pending' : phase?.progress === 100 ? 'Completed' : 'Ongoing'}
        </span>
      </div>

      {isFuturePhase && estimatedStartDate && (
        <div className="mb-4 p-4 bg-blue-50 dark:bg-blue-950/20 border border-blue-200 dark:border-blue-800 rounded-lg">
          <div className="flex items-start gap-3">
            <Icon name="Calendar" size={20} color="var(--color-blue-600)" className="flex-shrink-0 mt-0.5" />
            <div>
              <p className="text-sm font-medium text-blue-900 dark:text-blue-100 mb-1">
                Estimated Start Date: {new Date(estimatedStartDate)?.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
              </p>
              {previousPhaseProgress >= 90 && (
                <p className="text-sm text-blue-700 dark:text-blue-300 font-semibold">
                  Get ready to begin soon - previous phase is {previousPhaseProgress}% complete
                </p>
              )}
            </div>
          </div>
        </div>
      )}

      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        <Icon name="Calendar" size={16} strokeWidth={2} />
        <span>Phase {phase?.order || 1} of Project Timeline</span>
      </div>
    </div>
  );
};

export default PhaseHeader;